import React from 'react'
import { InputNumber } from 'primereact/inputnumber'

const NumericEditor = ({ options, validationErrors, min, max, minFractionDigits, maxFractionDigits }) => {
    const rowIndex = options.rowIndex

    // Build props object, only including optional props if they are defined
    const inputProps = {
        value: options.value,
        onValueChange: (e) => options.editorCallback(e.target.value),
        className: validationErrors[rowIndex] && validationErrors[rowIndex][options.field] ? 'p-invalid' : '',
        useGrouping: false
    }

    if (min !== undefined) inputProps.min = min
    if (max !== undefined) inputProps.max = max
    if (minFractionDigits !== undefined) inputProps.minFractionDigits = minFractionDigits
    if (maxFractionDigits !== undefined) inputProps.maxFractionDigits = maxFractionDigits

    return <InputNumber {...inputProps} />
}

export default NumericEditor
